<template>
  <div class="blue-bg">
    
    <section class="container">
      <div class="container-wrap">
        <h3>用户协议</h3>
        <p>生效日期：【2025年11月14日】</p>
        <div class="container-info">
          <p>欢迎使用瀚林愿教育AI成长平台！</p>
          <p>请务必在注册和使用前，认真、完整地阅读并理解本《用户协议》（以下简称“本协议”）。本协议由您（以下简称“用户”或“您”）与【苏州瀚易特信息技术股份有限公司】（以下简称“本公司”或“我们”）共同签订，旨在阐述您在使用本公司运营的“瀚林愿教育AI成长平台”官方网站（以下简称“本网站”或“平台”）时所享有的权利、承担的义务以及遵守的规则。<strong>您的注册、登录、浏览、使用等行为即视为您已阅读、理解并同意接受本协议全部内容的约束。如果您不同意本协议的任何内容，请立即停止访问或使用本网站。</strong></p>

          <h5>一、 协议的接受与变更</h5>
          <p>1.1 当您完成注册或开始使用本网站服务时，即表示您已具备与本公司签订本协议的法律能力（若您未满18周岁，请在法定监护人陪同下阅读并判断是否同意本协议），并同意受本协议所有条款的约束。</p>

          <p>1.2 我们有权在必要时对本协议进行修订。对于<strong>实质性变更</strong>（包括但不限于服务范围、用户权利义务、责任限制等重大变化），我们将通过本网站公告、站内通知或您预留的电子邮箱等一种或多种方式进行通知，并明确变更生效日期。若您在该生效日期后继续使用本网站服务，即表示您已接受经修订的协议。若您不同意变更后的内容，您有权并应当停止使用本网站服务。</p>

          <h5>二、 服务说明</h5>
          <p>2.1 本网站致力于为您提供“首页”“产品介绍”“案例中心”“公司简介”“合作与服务”“资讯中心”和“联系我们”几个模块的内容，具体的服务内容可能随时间、技术或政策要求进行调整、更新或中断，我们将尽力维护服务的稳定性与安全性。</p>

            <p>2.2 您理解并同意，为保障服务的质量与安全，我们有权对服务内容、服务模式等进行调整、更新或优化，或因定期及不定期的维护而暂停部分或全部服务。对于因不可抗力、第三方服务故障、网络攻击或法律法规及政策变动等<strong>非因我们过错导致的服务中断、终止或数据丢失，我们将在法律允许的范围内免除相应责任。</strong></p>

          <h5>三、 用户行为规范</h5>
          <p>3.1 您在使用本网站服务时，必须遵守中华人民共和国相关法律法规，并保证不得从事以下行为：<br/>
              1) 传输或发表任何煽动分裂国家、破坏国家统一、颠覆国家政权和社会主义制度、损害国家安全和荣誉的言论；<br/>
              2) 传输或发表任何侮辱、诽谤、淫秽、暴力、恐怖或教唆犯罪的言论；<br/>
              3) 利用本网站从事窃取商业秘密、窃取个人信息等违法犯罪活动；<br/>
              4) 从事任何可能对本网站系统造成不正常干扰或破坏计算机信息系统安全的行为，包括但不限于使用恶意代码、发起网络攻击、进行未经授权的扫描或探测等；<br/>
              5) 发布任何侵犯他人肖像权、知识产权、商业秘密、隐私权等合法权利的资讯、资料、文字、软件、图片、音频、视频等内容。</p>

              <p>3.2 您通过本网站“在线留言”、注册账号等功能向我们提交信息时，应保证所填写的信息（如姓名、公司、职位、电话、邮箱等）真实、准确、完整、合法。因您提交的信息不真实、不准确或不完整而导致的任何损失或责任，由您自行承担。</p>

                <p>3.3 您理解并同意，如您违反本协议项下的任何规定，我们有权依据违规情节的严重程度，采取包括但不限于警告、限制或暂停部分/全部服务功能、终止向您提供服务等一项或多项措施，且无需因此向您或任何第三方承担任何责任。若我们的行为因此遭受任何损失（包括但不限于对第三方的赔偿、行政罚款及合理的律师费、调查取证费用），您应承担相应的赔偿责任。</p>

          <h5>四、 知识产权</h5>
          <p>4.1 本网站包含的所有内容，包括但不限于文字、图形、徽标、按钮图标、图像、音频片段、数字下载、数据编辑、软件、界面设计及其组合，均归本公司或内容提供者所有，并受中国和国际版权法及相关知识产权法律法规的保护。</p>

            <p>4.2 未经本公司或相关权利人事先书面许可，您不得以任何方式复制、模仿、修改、发行、公开展示、传输、散布、反向工程、反编译、反汇编或利用本网站的任何内容，用于任何商业或公共目的。</p>

              <p>4.3 对于您通过本网站“在线留言”等功能上传、发布或提交的任何内容（“用户内容”），您仍保留原有的知识产权。但您在此授予本公司一项全球范围内、免费、不可撤销、非独家的许可，使我们有权为运营、推广和改进本网站服务之目的，使用、复制、修改、改编、发布、翻译和展示此类用户内容。</p>

          <h5>五、 隐私与个人信息保护</h5>
          <p>我们高度重视您的个人信息保护。关于我们如何收集、使用、存储、共享和保护您的个人信息，请您详细阅读并遵守我们另行制定的<strong>《隐私政策》。《隐私政策》构成本协议不可分割的一部分。您同意，您在使用本网站服务的行为即代表您已同意《隐私政策》的全部内容。</strong></p>

          <h5>六、 免责声明</h5>
          <p>6.1 本网站所展示的公司信息、产品介绍、案例、资讯等内容仅供参考，不构成任何承诺、要约或保证。具体合作细节需以双方另行签订的正式书面协议为准。</p>

            <p>6.2 我们致力于为您提供准确、可靠的服务，但无法保证所有信息绝对准确无误或服务全程不中断。在法律允许的范围内，我们对信息的准确性、完整性、及时性不作任何明示或默示的担保。您因依赖这些信息而作出的任何决定，风险由您自行承担。</p>

              <p>6.3 对于因不可抗力或我们无法合理控制的原因（如政府管制、基础电信网络中断、自然灾害等）导致的损失，我们不承担责任。对于黑客攻击、计算机病毒等安全威胁，我们将尽商业上合理的努力进行防范，并在发生此类事件时采取及时合理的补救措施。</p>

          <h5>七、 法律适用与管辖</h5>
          <p>7.1 本协议的订立、执行、解释及争议的解决均适用中华人民共和国法律（不包括冲突法）。</p>

            <p>7.2 如就本协议内容或其执行发生任何争议，双方应首先友好协商解决；协商不成的，<strong>任何一方均有权将争议提交至本公司所在地或有管辖权的人民法院通过诉讼解决。</strong></p>

          <h5>八、 其他</h5>
          <p>8.1 本协议中的任何条款无论因何种原因部分无效或不可执行，其余条款仍保持完全有效，并具有法律约束力。</p>

            <p>8.2 本协议构成您与我们之间就本网站服务所达成的完整协议，并取代您与我们之前就本网站服务所达成的任何口头或书面约定。</p>

          <h5>九、 联系我们</h5>
          <p>如果您对本协议或本网站服务有任何疑问、意见或建议，请通过以下方式与我们联系：发送邮件至<strong>info@hanit.cn，</strong>或拨打客服电话<strong>0512-6937-6383</strong>。</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted} from 'vue'
import { usePageSeo } from '~/composables/useSeo'
// 使用useHead替代usePageSeo避免middleware中的警告
usePageSeo({
  title: '预约洽谈-苏州瀚易特信息技术股份有限公司',
  description: '',
  keywords: '',
  url: 'consultation'
})
</script>

<style scoped lang="scss">
@use "sass:color";
@use "~~/assets/scss/main.scss" as *;

.container {
  line-height: 2;
  font-size: 14px;
  color: rgba(0,0,0,0.8);
  .container-wrap {
    padding: 100px 0;
  }
  .container-info {
    border-top: 1px solid #DEE7F3;
    padding-top: 20px;
  }
  p {
    margin-bottom: 10px;
  }
  h3 {
    color: rgba(0,0,0,0.9);
  }
  h5 {
    margin: 30px 0 10px;
    color: rgba(0,0,0,0.9);
  }
}
</style>